export default {
  http: {
    request: 'Request error',
    repetition: 'Repeated request',
    timeout: 'Timeout',
    err: 'Failed to connect to the server.'
  },
}
